(() => {
  const finePointer = window.matchMedia('(hover: hover) and (pointer: fine)');

  const bindMenus = () => {
    document.querySelectorAll('.sevenk-desktop-menu__parent-link, .sevenk-mobile-menu__parent-link').forEach((link) => {
      if (link.dataset.sevenkParentReady === 'true') return;
      link.dataset.sevenkParentReady = 'true';
      link.addEventListener('click', (event) => event.stopPropagation());
    });

    document.querySelectorAll('[data-sevenk-hover-menu]').forEach((menu) => {
      if (menu.dataset.sevenkHoverReady === 'true') return;
      const details = menu.querySelector(':scope > details');
      if (!details) return;
      menu.dataset.sevenkHoverReady = 'true';

      let closeTimer;
      const cancelClose = () => {
        window.clearTimeout(closeTimer);
        closeTimer = undefined;
      };
      const closeOthers = () => {
        document.querySelectorAll('[data-sevenk-hover-menu] > details[open]').forEach((openDetails) => {
          if (openDetails !== details) openDetails.removeAttribute('open');
        });
      };
      const open = () => {
        if (!finePointer.matches) return;
        cancelClose();
        closeOthers();
        details.setAttribute('open', '');
      };
      const scheduleClose = () => {
        if (!finePointer.matches) return;
        cancelClose();
        closeTimer = window.setTimeout(() => details.removeAttribute('open'), 420);
      };

      menu.addEventListener('pointerenter', open);
      menu.addEventListener('pointerleave', scheduleClose);
      details.addEventListener('focusin', open);
      details.addEventListener('focusout', () => {
        window.setTimeout(() => {
          if (!details.contains(document.activeElement)) scheduleClose();
        });
      });
    });
  };

  document.addEventListener('DOMContentLoaded', bindMenus);
  document.addEventListener('shopify:section:load', bindMenus);
  bindMenus();
})();
